import ConfirmModal from "components/confirm-modal";
import { ComponentProps } from "react";
import { useForm } from "react-hook-form";
import styles from "./PrebuiltTemplatesModal.module.scss";

type Inputs = {
  mode: "custom" | "pre-built";
};

const AddTemplateModal = ({
  show,
  onCancel,
  onApply,
}: Pick<ComponentProps<typeof ConfirmModal>, "show" | "onCancel"> & {
  onApply: (option: "custom" | "pre-built") => void;
}) => {
  const { register, getValues } = useForm<Inputs>({
    defaultValues: { mode: "custom" },
  });

  return (
    <ConfirmModal
      labelCancel="Cancel"
      showHeaderDivider={true}
      show={show}
      onCancel={onCancel}
      onConfirm={() => onApply(getValues("mode"))}
      labelTitle="Add New"
      children={
        <div className={styles["add-new"]}>
          <div className={"mb-4"}>
            Choose a template type to add to your library:
          </div>
          <label htmlFor={"custom"} className={styles["add-new__item"]}>
            <input
              type="radio"
              id="custom"
              value="custom"
              {...register("mode", { required: true })}
            />
            <div className={styles["add-new__item-content"]}>
              <div className={styles["add-new__item-content-title"]}>
                Custom Template
              </div>
              <div className={styles["add-new__item-content-description"]}>
                Create a template from scratch.
              </div>
            </div>
          </label>

          <label htmlFor={"pre-built"} className={styles["add-new__item"]}>
            <input
              type="radio"
              id="pre-built"
              value="pre-built"
              {...register("mode", { required: true })}
            />
            <div className={styles["add-new__item-content"]}>
              <div className={styles["add-new__item-content-title"]}>
                Pre-Built Template
              </div>
              <div className={styles["add-new__item-content-description"]}>
                Choose from pre-built templates that can be customized for your
                practice.
              </div>
            </div>
          </label>
        </div>
      }
      labelConfirm="Add"
    />
  );
};

export default AddTemplateModal;
